
export { CollectionName } from "/codebuild/output/src1483333825/src/packages/search-document-builders/src/registry/collection-registry.ts"
export { collectionAlias } from "./registry/schema-registry"